import { ErrorHandler, Injectable } from "@angular/core";
import { MonitoringService } from "./monitoring-service";
import { IonicErrorHandler } from "ionic-angular";

@Injectable()
export class ErrorHandlerService extends IonicErrorHandler {

    constructor(private monitoringService: MonitoringService) {
        super();
    }

    handleError(error: Error) {
        this.monitoringService.logException(error); // Manually log exception
        super.handleError(error);
    }
}


// WEBPACK FOOTER //
// ./src/services/AppInsights/error-handler.ts